import { useState } from "react";
import { ArrowLeftRight } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export function ExchangeRateButton({ fx, onSave }) {
  const [open, setOpen] = useState(false);
  const [rate, setRate] = useState("");
  const [to, setTo] = useState("INR");
  const openDialog = () => {
    setRate(fx?.aed_to_inr ? String(fx.aed_to_inr) : "");
    setTo(fx?.combine_in || "INR");
    setOpen(true);
  };
  const valid = Number(rate) > 0;
  const save = async (clear) => {
    const ok = await onSave({ aed_to_inr: clear ? null : Number(rate), combine_in: to });
    if (ok) setOpen(false);
  };
  return (
    <>
      <Button variant="outline" className="border-slate-300" onClick={openDialog} data-testid="exchange-rate-button">
        <ArrowLeftRight size={16} />{fx?.aed_to_inr ? `1 AED = ₹${fx.aed_to_inr}` : "Exchange rate"}
      </Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent data-testid="exchange-rate-dialog">
          <DialogHeader>
            <DialogTitle className="font-heading">Combined total</DialogTitle>
            <DialogDescription>Optional. Set a rate to also see one combined total when the sheet has both ₹ and AED staff.</DialogDescription>
          </DialogHeader>
          <div className="space-y-4">
            <div className="space-y-1.5">
              <Label className="text-xs font-semibold text-slate-600">1 AED equals (₹)</Label>
              <Input type="number" min="0" step="0.01" value={rate} onChange={(e) => setRate(e.target.value)} placeholder="e.g. 23.50" className="num-input" data-testid="exchange-rate-input" />
            </div>
            <div className="space-y-1.5">
              <Label className="text-xs font-semibold text-slate-600">Show combined total in</Label>
              <Select value={to} onValueChange={setTo}>
                <SelectTrigger data-testid="combine-currency-select"><SelectValue /></SelectTrigger>
                <SelectContent>
                  <SelectItem value="INR" data-testid="combine-currency-INR">Indian Rupee (₹)</SelectItem>
                  <SelectItem value="AED" data-testid="combine-currency-AED">UAE Dirham (AED)</SelectItem>
                </SelectContent>
              </Select>
            </div>
          </div>
          <DialogFooter className="gap-2">
            {fx?.aed_to_inr && <Button variant="ghost" className="text-red-600" onClick={() => save(true)} data-testid="exchange-rate-clear">Remove rate</Button>}
            <Button className="bg-teal-600 hover:bg-teal-700" onClick={() => save(false)} disabled={!valid} data-testid="exchange-rate-save">Save</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
}
